(function () {
  'use strict';

  function initSwiper(el) {
    if (el.dataset.swiperInit) return;
    el.dataset.swiperInit = '1';

    var track = el.querySelector('.pc-swiper__track');
    var dots = el.querySelectorAll('.pc-swiper__dot');
    var count = el.querySelectorAll('.pc-swiper__slide').length;

    if (count <= 1) return;

    var current = 0;
    var startX = 0;
    var startY = 0;
    var dragging = false;
    var didSwipe = false;

    function goTo(index) {
      current = Math.max(0, Math.min(index, count - 1));
      track.style.transform = 'translateX(-' + current * 100 + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    // ── Touch swipe ───────────────────────────────────────────────────────────

    el.addEventListener('touchstart', function (e) {
      e.stopPropagation();
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dragging = true;
      didSwipe = false;
    }, { passive: true });

    el.addEventListener('touchend', function (e) {
      if (!dragging) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 30) {
        didSwipe = true;
        goTo(dx < 0 ? current + 1 : current - 1);
      }
      dragging = false;
    }, { passive: true });

    // ── Mouse drag (desktop) ─────────────────────────────────────────────────

    var mouseStartX = 0;
    var mouseDown = false;

    el.addEventListener('mousedown', function (e) {
      mouseStartX = e.clientX;
      mouseDown = true;
      didSwipe = false;
      e.preventDefault();
    });

    window.addEventListener('mouseup', function (e) {
      if (!mouseDown) return;
      var dx = e.clientX - mouseStartX;
      if (Math.abs(dx) > 30) {
        didSwipe = true;
        goTo(dx < 0 ? current + 1 : current - 1);
      }
      mouseDown = false;
    });

    // ── Click to navigate (swiper is above the link overlay) ─────────────────

    var card = el.closest('product-card');
    if (card) {
      var overlay = card.querySelector('.product-card__link-overlay');
      if (overlay) {
        el.addEventListener('click', function (e) {
          if (didSwipe) {
            didSwipe = false;
            return;
          }
          // Let normal taps navigate to product page
          overlay.click();
        });
      }
    }

    // ── Dot clicks ────────────────────────────────────────────────────────────

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(i);
        didSwipe = true;
        setTimeout(function () { didSwipe = false; }, 400);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.js-pc-swiper:not([data-swiper-init])').forEach(initSwiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after section loads in theme editor
  document.addEventListener('shopify:section:load', initAll);

  // Re-init for dynamically inserted cards (tabs, infinite scroll)
  var mutationTimer;
  var observer = new MutationObserver(function () {
    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(initAll, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
